import { LuClock, LuMapPin, LuImage } from "react-icons/lu";
import "../../styles/events/eventCard.css";
import { getFullWrittenDate, getHoursAndMinutes, getNumericDate, getShortWrittenMonth } from "../../utils/date";


//CARTE D'UN ÉVÈNEMENT : affiche, date, titre, infos pratiques et bouton vers le détail
function EventCard({ event, onSelect }) {

  //Inscription préalable (sur HelloAsso) : badge "Inscriptions ouvertes" et bouton rouge
  const withRegistration = event.subscription === true;

  return (
    <article className="event_card">
      <div className="event_card_poster">
        {event.poster
          ? <>
            <div className="event_card_poster_blur" style={{ backgroundImage: `url(${event.poster})` }} aria-hidden="true" />
            <img src={event.poster} alt={`Affiche : ${event.title}`} className="event_card_poster_img" />
          </>
          : <div className="event_card_poster_empty">
            <LuImage aria-hidden="true" />
            <span>Affiche à venir</span>
          </div>}
        {/* Pastille de date seulement si l'évènement a une date de début */}
        {event.startDate && (
          <div className="event_card_date" aria-hidden="true">
            <span className="event_card_day">{getNumericDate(event.startDate)}</span>
            <span className="event_card_month">{getShortWrittenMonth(event.startDate).replace(".", "")}</span>
          </div>
        )}
        {withRegistration && <span className="badge badge--success event_card_badge">Inscriptions ouvertes</span>}
      </div>
      <div className="event_card_body">
        <h3 className="event_card_title">{event.title}</h3>
        {event.shortDescription && <p className="event_card_description">{event.shortDescription}</p>}
        <ul className="event_card_meta">
          {event.startDate && <li><LuClock aria-hidden="true" />{getFullWrittenDate(event.startDate)} à {getHoursAndMinutes(event.startDate)}</li>}
          {(event.place || event.city) && <li><LuMapPin aria-hidden="true" />{[event.place, event.city].filter(Boolean).join(", ")}</li>}
        </ul>
        <button
          onClick={() => onSelect(event)}
          className={`btn ${withRegistration ? "btn--primary" : "btn--secondary"} event_card_button`}
        >
          {withRegistration ? "En savoir plus et s’inscrire" : "En savoir plus"}
        </button>
      </div>
    </article>
  )
};

export default EventCard;
